export const STORAGE_AREA_NONE_ID = 'none';
